import api, { apiPrefix } from './Api';
import {
  OfferSummary,
  offerSummaryFromResponse,
} from '../interfaces/Offer/OfferSummary';

const offerApiPrefix = `${apiPrefix}/offers`;

export const getValidOffers = async (): Promise<OfferSummary[]> => {
  const response = await api.get(offerApiPrefix);

  return (response.data?.data ?? []).map(offerSummaryFromResponse);
};

export const getOffer = async (id: number): Promise<OfferSummary> => {
  const response = await api.get(`${offerApiPrefix}/${id}`);

  return offerSummaryFromResponse(response.data?.data);
};
